export default "__VITE_ASSET__BQynV3UR__"